import { Handshake, ArrowRight } from "lucide-react";
import { HERO } from "@/constants/testIds";
import NetworkGraphic from "@/components/NetworkGraphic";
import { useVerificationDialog } from "@/contexts/VerificationDialogContext";

export default function Hero() {
  const { openDialog } = useVerificationDialog();

  return (
    <section id="top" data-testid={HERO.section} className="relative bg-white">
      <div className="absolute inset-0 bg-grid opacity-60 pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10 pt-16 pb-20 lg:pt-24 lg:pb-32 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-7 reveal">
          <div
            data-testid={HERO.trustBadge}
            className="inline-flex items-center gap-2 border border-slate-200 bg-slate-50/80 px-3 py-1.5 rounded-sm text-[11px] uppercase tracking-[0.22em] font-bold text-slate-700"
          >
            <Handshake size={14} className="text-emerald-700" />
            B2B Sourcing · Cross-Border Procurement · US–DR Trade
          </div>

          <h1
            data-testid={HERO.headline}
            className="font-display mt-7 text-4xl sm:text-5xl lg:text-[60px] leading-[1.05] tracking-tight font-light text-slate-900"
          >
            Your{" "}
            <span className="font-semibold">Strategic Bridge</span> for US &amp;
            Dominican Republic B2B Procurement.
          </h1>

          <p
            data-testid={HERO.subheadline}
            className="mt-7 max-w-2xl text-lg text-slate-600 leading-relaxed"
          >
            We connect American companies with{" "}
            <span className="font-semibold text-slate-900">
              top-tier suppliers
            </span>{" "}
            in the Dominican Republic. From vendor sourcing to cross-border
            negotiation, we facilitate seamless international trade across all
            industries.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button
              type="button"
              onClick={openDialog}
              data-testid={HERO.ctaWhatsapp}
              className="group inline-flex items-center justify-center gap-2 bg-[#B45309] hover:bg-[#92400E] text-white px-7 py-4 text-[15px] font-semibold tracking-tight rounded-sm transition-all shadow-sm hover:shadow-md"
            >
              <Handshake size={18} />
              Start Sourcing
              <ArrowRight
                size={17}
                className="transition-transform group-hover:translate-x-1"
              />
            </button>
            <a
              href="#methodology"
              data-testid={HERO.ctaLearnMore}
              className="inline-flex items-center justify-center gap-2 border border-slate-300 hover:border-slate-900 text-slate-900 px-7 py-4 text-[15px] font-semibold tracking-tight rounded-sm transition-colors"
            >
              Schedule a Consultation
            </a>
          </div>

          <div className="mt-12 grid grid-cols-3 max-w-lg gap-6">
            <Stat value="US ↔ DR" label="Cross-Border Trade" />
            <Stat value="Local" label="Trade Liaison" />
            <Stat value="Vetted" label="Supplier Network" />
          </div>
        </div>

        <div data-testid={HERO.graphic} className="lg:col-span-5 reveal">
          <NetworkGraphic />
        </div>
      </div>
      <div className="divider-line" />
    </section>
  );
}

function Stat({ value, label }) {
  return (
    <div>
      <div className="font-display text-2xl sm:text-3xl font-semibold text-slate-900 tracking-tight">
        {value}
      </div>
      <div className="eyebrow mt-2">{label}</div>
    </div>
  );
}
